import React, { useMemo, useState } from "react";
import DocumentRow from "./DocumentRow";
import DocumentSection from "./DocumentSection";
import DocumentsManager from "./DocumentsManager";
import styles from "./DocumentsManager.module.css";

export interface IDocumentItem {
  uid_documento: string;
  uid_tipo_documento: string;
  tipo: string;
  titulo: string;
  inicio: string;
  fim: string;
  grupo: string;
  auxiliary?: boolean;
}

interface DocumentsListProps {
  data: IDocumentItem[];
  onAdd?: () => void;
  onSettings?: () => void;
  onView?: (doc: IDocumentItem) => void;
  onUpload?: (doc: IDocumentItem) => void;
  onDownload?: (doc: IDocumentItem) => void;
  onCopy?: (doc: IDocumentItem) => void;
  onDelete?: (doc: IDocumentItem) => void;
}

const DocumentsList = ({
  data,
  onAdd,
  onSettings,
  onView,
  onUpload,
  onDownload,
  onCopy,
  onDelete
}: DocumentsListProps) => {
  const [expandedGroups, setExpandedGroups] = useState<Record<string, boolean>>({});

  const groupedData = useMemo(() => {
    return data.reduce((acc, curr) => {
      if (!acc[curr.grupo]) acc[curr.grupo] = [];
      acc[curr.grupo].push(curr);
      return acc;
    }, {} as Record<string, IDocumentItem[]>);
  }, [data]);

  const toggleGroup = (groupName: string) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupName]: !prev[groupName],
    }));
  };

  return (
    <DocumentsManager onAdd={onAdd} onSettings={onSettings}>
      <table className={styles.customTable}>
        <tbody>
          {Object.entries(groupedData).map(([sectionTitle, items]) => {
            const isOpen = !!expandedGroups[sectionTitle];

            return (
              <React.Fragment key={sectionTitle}>
                <DocumentSection
                  title={sectionTitle}
                  count={items.length}
                  isOpen={isOpen}
                  onToggle={() => toggleGroup(sectionTitle)}
                />

                {isOpen && (
                  <>
                    <tr className={styles.headerRow}>
                      <th className={styles.colIndex}>#</th>
                      <th className={styles.colType}>Tipo de documento</th>
                      <th className={styles.colTitle}>Título</th>
                      <th className={styles.colDate}>Vigência Início</th>
                      <th className={styles.colDate}>Vigência Fim</th>
                      <th className={styles.colAction}>Ação</th>
                    </tr>

                    {items.map((item, index) => (
                      <DocumentRow
                        key={item.uid_documento}
                        index={index + 1}
                        tipo={item.tipo}
                        titulo={item.titulo}
                        inicio={item.inicio}
                        fim={item.fim}
                        auxiliary={item.auxiliary}
                        onView={() => onView?.(item)}
                        onUpload={() => onUpload?.(item)}
                        onDownload={() => onDownload?.(item)}
                        onCopy={() => onCopy?.(item)}
                        onDelete={() => onDelete?.(item)}
                      />
                    ))}
                  </>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </DocumentsManager>
  );
};

export default DocumentsList;